import styled from "styled-components"

type TabButtonColorNameType =
  | 'charcoal'
  | 'stone'
  | 'yellow'
  | 'cyan'
  | 'white'

type TabButtonColorValueType = {
  color: string;
  bgClr: string;
}

const BTN_COLOR: Record<TabButtonColorNameType, TabButtonColorValueType> = {
  'charcoal': { color: '#FBFBFB', bgClr: '#272727' },
  'yellow'  : { color: '#FBFBFB', bgClr: '#F19915' },
  'stone'   : { color: '#272727', bgClr: '#E5E0D7' },
  'cyan'    : { color: '#272727', bgClr: '#B4F1DB' },
  'white'   : { color: '#272727', bgClr: '#FBFBFB' },
}

type ButtonProps = {
  $size: 'small' | 'normal';
  $color: TabButtonColorNameType;
}

export const Button = styled.button<ButtonProps>`
  padding: ${props => (props.$size === 'small') ? '4px 20px':'15px 30px'};
  border-radius: 55px;
  border: none;
  color: ${props => BTN_COLOR[props.$color].color};
  background-color: ${props=> BTN_COLOR[props.$color].bgClr};
  &.frame {
    color: var(--clr-charcoal);
    background-color: transparent;
    border: 1px solid ${props=> BTN_COLOR[props.$color].bgClr};
  }
  &.tab {
    border-radius: 0 55px 55px 0;
  }
`
